import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import draggable from "vuedraggable";
import YYImage from "@/pages/design/components/basic/image";
import FormEditPage from '@/pages/design/components/FormEditPage';
import CardItem from "@/pages/design/components/CardItem";
import Title from "@/pages/design/components/Title";
import FileUpload from "@/pages/design/components/FileUpload";
import { mapState } from 'vuex';
import defaultImage from '@/resource/images/default-banner.png';
import PdfUpload from "../FileUpload/pdfUpload.vue";
import GoodsListField from "@/pages/design/components/GoodsListField/index.vue";
import SelectProduct from '@/components/commonAdd/selectGroupGoods.vue';
import { designGetProductList } from '@/services/design';
import SetSearchParamsModal from "@/pages/design/components/SetSearchParamsModal/SetSearchParamsModal.vue";
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    id: [Number, String]
  },
  components: {
    SetSearchParamsModal: SetSearchParamsModal,
    draggable: draggable,
    YYImage: YYImage,
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    FileUpload: FileUpload,
    Title: Title,
    PdfUpload: PdfUpload,
    GoodsListField: GoodsListField,
    SelectProduct: SelectProduct
  },
  data: function data() {
    return {
      defaultImage: defaultImage,
      showSlide: false,
      curImgItem: 0,
      // 点击编辑图片时的索引
      pdfList: [],
      // pdf 列表
      // 广告图类型
      BannerTypes: {
        // 链接
        Link: 1,
        // 主题
        Subject: 2
      },
      invalidList: [],
      componentPathLink: this.value,
      searchParamsVisible: false // 设置搜索条件弹窗
    };
  },
  watch: {
    value: function value(newValue) {
      this.componentPathLink = newValue;
    },
    componentPathLink: function componentPathLink() {
      this.$emit('input', this.componentPathLink);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    },
    langId: function langId(state) {
      return state.design.langId;
    },
    clientPublicData: function clientPublicData(state) {
      return state.design.clientPublicData;
    }
  })), {}, {
    list: function list() {
      if (!this.componentPathLink[this.curImgItem].path) {
        return [];
      }
      return [this.$store.state.design.imgHost + this.componentPathLink[this.curImgItem].path];
    },
    imgSrc: function imgSrc() {
      return function (path) {
        if (!path) return this.defaultImage;else return this.imgHost + path;
      };
    }
  }),
  methods: {
    /**
     *  处理设置搜索条件弹窗点击确定
     * @param links
     */
    handleSearchParamsOk: function handleSearchParamsOk(links) {
      console.log('links', links);
      this.componentPathLink[this.curImgItem].link = links;
      // componentPathLink[curImgItem].link
      // this.langList.forEach(lang => {
      //   this.value.titles[this.curMenuItem].title[lang.langId].link = (this.siteDomain || '') + links[lang.langId]
      // })
    },
    // 专题和连接类型切换
    onTypeChange: function onTypeChange(e) {
      console.log('e', e);
      this.componentPathLink[this.curImgItem].type = e.target.value;

      // 初始化 product productList subjectTitle
      if (typeof this.componentPathLink[this.curImgItem].product === 'undefined') {
        this.$set(this.componentPathLink[this.curImgItem], 'product', []);
      }
      if (typeof this.componentPathLink[this.curImgItem].productList === 'undefined') {
        this.$set(this.componentPathLink[this.curImgItem], 'productList', []);
      }
      if (typeof this.componentPathLink[this.curImgItem].subjectTitle === 'undefined') {
        this.$set(this.componentPathLink[this.curImgItem], 'subjectTitle', {});
      }

      // 当从专题切换到链接时， 清空product和productList subjectTitle
      if (this.componentPathLink[this.curImgItem].type == this.BannerTypes.Link) {
        this.componentPathLink[this.curImgItem].product = [];
        this.componentPathLink[this.curImgItem].productList = [];
        this.componentPathLink[this.curImgItem].subjectTitle = {};
      } else {
        this.componentPathLink[this.curImgItem].name = '';
        this.componentPathLink[this.curImgItem].link = '';
      }
      this.$forceUpdate();
    },
    // 查看商品弹窗删除商品
    handleGoodsDelete: function handleGoodsDelete(deleteItem) {
      var productList = this.componentPathLink[this.curImgItem].productList.filter(function (item) {
        return item.productSpecificationId != deleteItem.productSpecificationId;
      });
      this.componentPathLink[this.curImgItem].productList = productList;
      this.componentPathLink[this.curImgItem].product = this.componentPathLink[this.curImgItem].productList.map(function (item) {
        return item.productSpecificationId;
      });
    },
    // 添加商品弹窗添加商品
    confirmProduct: function confirmProduct(data) {
      this.setProductList(data, 'addProduct');
    },
    // 显示添加商品弹窗
    addNewProduct: function addNewProduct() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.chooseProductRef.visible = true;
      });
    },
    setProductList: function setProductList(list, type) {
      var _this2 = this;
      if (typeof this.componentPathLink[this.curImgItem].product == 'undefined') {
        this.componentPathLink[this.curImgItem].product = [];
        this.componentPathLink[this.curImgItem].productList = [];
      }
      var productList = list.map(function (item) {
        return {
          productNo: type == 'import' ? item.goodsNo : item.productNo,
          productName: type == 'import' ? item.goodsName : item.productName,
          productDiscountPrice: type == 'import' ? item.price : item.productPrice,
          productStockNum: type == 'import' ? item.productStockNum : item.productStocknum,
          productSpecificationId: type == 'import' ? item.productSpecId : item.optionId,
          productSpecification: type == 'import' ? item.specName : item.specValueName,
          productStatus: item.productStatus
        };
      });
      if (type == 'import') {
        var _this$componentPathLi;
        // 去除重复的商品
        _.remove(productList, function (o) {
          return _this2.componentPathLink[_this2.curImgItem].productList.findIndex(function (item) {
            return item.productSpecificationId === o.productSpecificationId;
          }) !== -1; //o.productSpecId != oldItem.productOptionId;
        });
        (_this$componentPathLi = this.componentPathLink[this.curImgItem].productList).unshift.apply(_this$componentPathLi, _toConsumableArray(productList));
      } else {
        this.componentPathLink[this.curImgItem].productList = productList;
      }
      this.componentPathLink[this.curImgItem].product = this.componentPathLink[this.curImgItem].productList.map(function (item) {
        return item.productSpecificationId;
      });
    },
    handleClearPdf: function handleClearPdf() {},
    handlePdfUploadSuccess: function handlePdfUploadSuccess(val) {
      if (this.clientPublicData && val) {
        this.componentPathLink[this.curImgItem].link = encodeURIComponent(this.clientPublicData.catalogPageUrl + '?file=' + this.imgHost + val);
      }
    },
    handleConfirmDelete: function handleConfirmDelete(i) {
      this.componentPathLink.splice(i, 1);
    },
    handleClearImg: function handleClearImg() {
      this.componentPathLink[this.curImgItem].path = '';
    },
    handleUploadSuccess: function handleUploadSuccess(val) {
      this.componentPathLink[this.curImgItem].path = val;
      this.$emit('input', this.componentPathLink);
    },
    handleAddImg: function handleAddImg() {
      this.componentPathLink.push({
        path: '',
        link: '',
        name: '',
        nameId: new Date().getTime(),
        type: this.BannerTypes.Link,
        product: [],
        productList: []
      });
      this.curImgItem = this.componentPathLink.length - 1;
      this.showSlide = true;
    },
    handleDeleteImg: function handleDeleteImg() {
      this.componentPathLink.splice(this.curImgItem, 1);
      this.showSlide = false;
    },
    handleImgClick: function handleImgClick(i) {
      this.curImgItem = i;
      if (typeof this.componentPathLink[this.curImgItem].type === 'undefined') {
        this.$set(this.componentPathLink[this.curImgItem], 'type', this.BannerTypes.Link);
      }
      if (this.componentPathLink[this.curImgItem].type == this.BannerTypes.Subject) {
        this.getProductList(this.componentPathLink[this.curImgItem]);
      }
      this.showSlide = true;
    },
    getProductList: function getProductList(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(item.productList.length > 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return designGetProductList({
                moduleId: _this3.id,
                langId: _this3.langId,
                nameId: item.nameId || item.nameid,
                plate: 2,
                clentType: 1,
                page: 1,
                size: (item.product || []).length
              });
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                item.productList = res.data.data.productList;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};